import React, { useState } from "react";
import { Button, CircularProgress, Tooltip } from "@mui/material";
import { useSnackbar } from "notistack";
const ButtonWithAPICall = React.forwardRef(
  (
    {
      api,
      disableSnackbar = () => false,
      response,
      onClick,
      disabled,
      title = "",
      children,
      dialogNode,

      ...buttonProps
    },
    ref
  ) => {
    const [loading, setLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [open, setOpen] = useState(false); // for dialog
    const callAPI = () => {
      try {
        setLoading(true);
        setOpen(false);
        api &&
          api().then((res) => {
            setLoading(false);
            response && response(res);
            !disableSnackbar(res) && enqueueSnackbar(res.message, { variant: res.code === 200 ? "success" : "" });
          });
      } catch (error) {
        setLoading(false);
      }
    };
    const handleAccept = () => {
      // when click accept on dialog
      callAPI();
    };
    const handleClick = () => {
      // when click on button
      onClick && onClick();
      if (!dialogNode) callAPI();
      else setOpen(true);
    };
    if (title)
      return (
        <React.Fragment>
          <Tooltip title={title}>
            <Button ref={ref} {...buttonProps} onClick={handleClick} disabled={loading || disabled} style={{ position: "relative", whiteSpace: "nowrap", ...buttonProps.style }}>
              {children}
              {loading && <CircularProgress size={20} style={{ position: "absolute", left: "50%", top: "50%", marginTop: -10, marginLeft: -10 }} />}
            </Button>
          </Tooltip>
          {dialogNode && dialogNode({ open: open, onDecline: () => setOpen(false), onAccept: handleAccept })}
        </React.Fragment>
      );
    else
      return (
        <React.Fragment>
          <Button ref={ref} {...buttonProps} onClick={handleClick} disabled={loading || disabled} style={{ position: "relative", whiteSpace: "nowrap", ...buttonProps.style }}>
            {children}
            {loading && <CircularProgress size={10} style={{ position: "absolute", left: "50%", top: "50%", marginTop: -10, marginLeft: -10 }} />}
          </Button>
          {dialogNode && dialogNode({ open: open, onDecline: () => setOpen(false), onAccept: handleAccept })}
        </React.Fragment>
      );
  }
);
export default ButtonWithAPICall;
